<template>
  <b-row no-gutters id="lm-user-profile" class="wrapper-content w-100">
    <b-col cols="12" class="wrapper-content">
      <b-row class="wrapper-title-page">
        <b-col cols="12" class="d-flex  align-items-center">
          <h4 class="page-title">{{ $t('user_profile_title') }}</h4>
        </b-col>
      </b-row>
      <b-row>
        <div class="col-sm-12">
          <!-- Profile -->
          <div class="card bg-primary">
            <div class="card-body profile-user-box">

              <div class="row">
                <div class="col-sm-8">
                  <div class="media">
                    <span class="float-left m-2 mr-4">
                      <img  :src="avatar"  class="rounded-circle img-thumbnail">
                    </span>
                    <div class="media-body">
                      <h4 class="mt-1 mb-1 text-white">{{ username | capitalize }}</h4>
                      <!-- <p class="font-13 text-white-50"> Authorised Brand Seller</p> -->

                      <ul class="mb-0 list-inline text-light">
                        <!-- <li class="list-inline-item mr-3">
                          <h5 class="mb-1">$ 25,184</h5>
                          <p class="mb-0 font-13 text-white-50">Total Revenue</p>
                        </li>
                        <li class="list-inline-item">
                          <h5 class="mb-1">5482</h5>
                          <p class="mb-0 font-13 text-white-50">Number of Orders</p>
                        </li> -->
                      </ul>
                    </div> <!-- end media-body-->
                  </div>
                </div> <!-- end col-->

                <div class="col-sm-4">
                  <div class="text-center mt-sm-0 mt-3 text-sm-right">
                    <button type="button" class="btn btn-light">
                      <i class="mdi mdi-account-settings mr-1"></i> {{ $t('edit_profile') }}
                    </button>
                  </div>
                </div> <!-- end col-->
              </div> <!-- end row -->

            </div> <!-- end card-body/ profile-user-box-->
          </div>
          <!--end profile/ card -->
        </div>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('session', ['avatar', 'username'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      document.title = `Perfil ${vm.username} ${vm.$store.getters['settings/appName']} `
    })
  }
}
</script>

<style lang="sass" scoped>
  #lm-user-profile
    .media
      img
        height: 100px
</style>
